import { Divider } from "primereact/divider";
import { AddPageHeader } from "../Common/Utils";
import { Link } from "react-router-dom";

const Submissions = () => {
  return (
    <div>
      {AddPageHeader("Submission guidelines")}
      <div className="reduce-width">
        <Divider align="center">
          <h1>Submission guidelines</h1>
        </Divider>

        <div className="flex h-full gap-3" style={{ height: "100%" }}>
          <div className="flex-1">
            <a
              href="https://zenodo.org/communities/theconsularrepository/curation-policy"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="text-center p-3 border-round-sm bg-primary h-full flex flex-column justify-content-center">
                <div>
                  <b>Archive your existing documents</b>
                </div>
                <br />
                <div>The Consular Repository</div>
              </div>
            </a>
          </div>
          <div className="flex-1">
            <a
              href="https://magazine.consularaffairs.org/p/write-in-the-magazine"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="text-center p-3 border-round-sm bg-primary h-full flex flex-column justify-content-center">
                <div>
                  <b>Got an analysis, perspective, or story?</b>
                </div>
                <br />
                <div>The Consular Magazine</div>
              </div>
            </a>
          </div>
          <div className="flex-1">
            <Link
              to="/the-consular-bibliography"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="text-center p-3 border-round-sm bg-primary h-full flex flex-column justify-content-center">
                <div>
                  <b>Reference your writings</b>
                </div>
                <br />
                <div>The Consular Bibliography</div>
              </div>
            </Link>
          </div>
          <div className="flex-1">
            <a
              href="/pdf/cac-tcj-call-for-papers.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="text-center p-3 border-round-sm bg-primary h-full flex flex-column justify-content-center">
                <div>
                  <b>Submit an academic article </b>
                </div>
                <br />
                <div>The Consular Journal</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Submissions;
